import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';

@Component({
    selector: 'diana-items-pager',
    templateUrl: './items-pager.component.html',
    styleUrls: ['./items-pager.component.scss'],
    standalone: false
})
export class ItemsPagerComponent implements OnInit, OnChanges {
  @Input()
  showCount = true;

  @Input()
  totalItems = 0;

  @Input()
  currentIndex = 0;

  /**
   * Tells if the currenbt index/item is beyond the viewport.
   */
  get exceededViewport() {
    return this.currentIndex >= this.itemsThreshold;
  }

  get isLastElement() {
    return this.currentIndex === this.totalItems - 1;
  }

  itemsArray: Array<number> = [];
  itemsThreshold = 13;

  ngOnInit() {
    this.initLoopArray();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.totalItems && !changes.totalItems.firstChange) {
      this.initLoopArray();
    }
  }

  initLoopArray() {
    this.itemsArray = Array<number>(this.totalItems);
  }

  trackByIdx(index: number) {
    return index;
  }
}
